// Modules
import { HelmetProvider } from "react-helmet-async";

// Components
import SearchResults from "components/SearchResults/SearchResults";
import Sidebar from "components/Sidebar/Sidebar";
import BreadcrumbSchema from "containers/PageContent/BreadcrumbSchema";

interface PageContentProps {
	urlPath: string;
}

const PageContent = ({ urlPath }: PageContentProps) => {
	return (
		<>
			<HelmetProvider>
				<main role="main">
					<div className="container">
						<div className="breadcrumbs">
							<ul className="breadcrumbs__list">
								<li>
									<a href={process.env.NEXT_PUBLIC_DOMAIN}>
										<i className="fa fa-home"></i>
									</a>
								</li>
								<li>
									<i className="fa fa-angle-right" aria-hidden="true"></i>
								</li>
								<li>
									<span>Ricerca</span>
								</li>
							</ul>
						</div>
						<BreadcrumbSchema urlPath={urlPath}></BreadcrumbSchema>
						<SearchResults />
						<Sidebar />
					</div>
				</main>
			</HelmetProvider>
		</>
	);
};

export default PageContent;
